import type { AcidTheme } from './ThemeDefinitions';

export const DEFAULT_THEME: AcidTheme = 'light';
